import { render } from "./dialogWindow.vue?vue&type=template&id=45048fcb&scoped=true"
import script from "./dialogWindow.vue?vue&type=script&lang=js"
export * from "./dialogWindow.vue?vue&type=script&lang=js"

import "./dialogWindow.vue?vue&type=style&index=0&id=45048fcb&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45048fcb"]])

export default __exports__